import Map from 'ol/Map.js';
import $ from 'jquery';
import {Fill, Icon, Stroke, Style} from 'ol/style.js';
import View from 'ol/View.js';
import Overlay from 'ol/Overlay.js';
import Feature from 'ol/Feature.js';
import {fromLonLat} from 'ol/proj.js';
import {Point} from 'ol/geom.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import VectorSource from 'ol/source/Vector.js';
import OSM from 'ol/source/OSM';
import {defaults as defaultInteractions, Pointer as PointerInteraction} from 'ol/interaction.js';

export default function initMap() {
	
    function init() {
      var container = document.getElementById('popup');
      var closer = document.getElementById('popup-closer');
      var content = document.getElementById('popup-content');
      var tooltip = document.getElementById('tooltip');
        
      
      var getActiveCategory = function() {
        var selected = [];
        $('.maps__filter #map-checkbox input:checked').each(function() {
            if($(this).attr('value')==""){
                selected.push("tutti");
            }else{
                selected.push($(this).attr('value').toLowerCase());
            }
        });
        return selected;
      }

      var getActiveMarker = function(activeCategory) {
        var markers = [];
        //console.log("activeCategory",activeCategory);
        $(".ol__marker").each(function( index ) {
          var category = $( this ).data("cat").toLowerCase();
          //console.log("marker cat",category);
          if (activeCategory.includes(category) || activeCategory.includes("tutti")) {
            var lng = $( this ).data("lng");
            var lat = $( this ).data("lat");
            var iconUrl = $( this ).data("icon");
            var desc = $( this ).text();
            console.log(lng,lat,desc);
            var iconStyle = new Style({
              image: new Icon({
                anchor: [0.5, 46],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: iconUrl || '/assets/images/ico-marker.png'
              })
            });	
            var marker = new Feature({
                id: "cl_"+index,
                name: desc,
                description: desc,
                geometry: new Point(
                    fromLonLat([Number(lng),Number(lat)])
                ), 
                });
            marker.setStyle(iconStyle);  
            markers.push(marker);  
            }
        });
        return markers;
      }

      var displayFeatureInfo = function(evt) {
        var pixel = evt.pixel;
        var coordinate = evt.coordinate;
        var features = [];
        map.forEachFeatureAtPixel(pixel, function(feature) {
          features.push(feature);
        });
        if (features.length > 0) {
          var info = {};
          var i, ii;
          for (i = 0, ii = features.length; i < ii; ++i) {
            info.name = features[i].get('name');
            info.description = features[i].get('description');
          }
          tooltip.style.display = "none";
          content.innerHTML = '<strong>'+info.name+'</strong><br/><br/>'+(info.description || '');
          overlay.setPosition(coordinate);
          map.getTarget().style.cursor = 'pointer';
        } else {
          
          map.getTarget().style.cursor = '';
        }
      };
    
    
      closer.onclick = function() {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };
  
      var overlay = new Overlay({
        element: container,
        autoPan: true,
        autoPanAnimation: {
          duration: 250
        }
      });
  
      var tile = new TileLayer({
        source: new OSM()
      });
  
    

      var map = new Map({
        layers: [tile],
        interactions: defaultInteractions({mouseWheelZoom:false}),
        target: document.getElementById('map'),
        overlays: [overlay],
        view: new View({
          center: fromLonLat([12.444870,43.937940]),
          zoom: 12
        })
      });
      
      
      if ($('.maps__filter').length > 0) {
        var activeCategory = getActiveCategory();
        var markers = getActiveMarker(activeCategory);
        
        $('.maps__filter .form__checkbox ').on('change',function(e) {
            var activeCategory = getActiveCategory();
            var newmarkers = getActiveMarker(activeCategory);
            vector.setSource(new VectorSource({
              features: newmarkers
            }));
        })
      } else {
        var markers = getActiveMarker(['tutti']);
      }
      var sourceVector =  new VectorSource({
        features: markers
      });
      var vector = new VectorLayer({
        source: sourceVector
      });
      map.addLayer(vector);
      map.on('singleclick', function(evt) {
        displayFeatureInfo(evt);
      });
      map.getView().fit(sourceVector.getExtent(), { padding: [50, 50, 50, 50], constrainResolution: false, maxZoom: 17 });
     


    }

    if($('.ol #map').length > 0) {
        init();
    }
    
}    


// WEBPACK FOOTER //
// ./src/assets/js/maps.js